import { IFilters } from '@cian/valuation-main-filters-widget/es/shared/types';
import { ITrackAddNewFlatByNumberParameters } from './types';
import { trackAddNewFlatByNumberClick, trackAddNewFlatByNumberSubmit } from './tracking';

export const trackMyHomeWithFlatNumberAnalytics = (props: IFilters, isSubmit?: boolean) => {
  const submitAnalytics = isSubmit ? trackAddNewFlatByNumberSubmit : trackAddNewFlatByNumberClick;

  const { roomsCount, area, userSetArea, userSetRoomsCount, address, flatNumber } = props;

  const parameters: ITrackAddNewFlatByNumberParameters = {
    autofiiled: {
      roomsnumber: !userSetRoomsCount ? roomsCount : undefined,
      area: !userSetArea ? area : undefined,
    },
    result: {
      address,
      flatnumber: flatNumber,
      roomsnumber: roomsCount,
      area,
    },
  };

  return submitAnalytics(parameters);
};
